export type AnalyticsValue = string | number | boolean
export type AnalyticsParams = Record<string, AnalyticsValue | undefined>

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

export function trackEvent(name: string, params: AnalyticsParams = {}) {
  if (typeof window === 'undefined') return
  const clean = Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined))
  window.gtag?.('event', name, clean)
}

export function trackGameEvent(name: string, gameId: string, params: AnalyticsParams = {}) {
  trackEvent(name, { game_id: gameId, ...params })
}

export type GameResult = 'won' | 'lost'

const wonPatterns = [
  /\byou win\b/i, /\bwon\b/i, /\bcleared\b/i, /\bcomplete(?:d)?\b/i, /\brestored\b/i,
  /\bunlocked\b/i, /\bdelivered\b/i, /\bglowing\b/i, /\bflowing\b/i, /\bin tune\b/i,
  /\bsorted\b/i, /\bshift complete\b/i, /\bforged\b/i,
  /通关|完成|获胜|清空|接通|破解|复原|送达|点亮|平衡|和鸣|流动|归仓|入图/,
]

const lostPatterns = [
  /\bgame over\b/i, /\blost\b/i, /\btray full\b/i, /\bdepleted\b/i, /\bstranded\b/i,
  /\bsignal lost\b/i, /\bout of\b/i, /\bno .+ left\b/i, /\btests used\b/i, /\bsignals used\b/i,
  /游戏结束|失败|耗尽|中断|已满|用完|丢失|电脑获胜|信号已经耗尽/,
]

export function classifyResultText(text: string): GameResult | null {
  if (wonPatterns.some(pattern => pattern.test(text))) return 'won'
  if (lostPatterns.some(pattern => pattern.test(text))) return 'lost'
  return null
}

export function parseScoreText(text: string): number | undefined {
  const match = text.replace(/,/g, '').match(/-?\d+(?:\.\d+)?/)
  if (!match) return undefined
  const score = Number(match[0])
  return Number.isFinite(score) ? score : undefined
}
